export default "__VITE_ASSET__C4XPMuP5__"